exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".AdminWellnessDvmCommission__root{margin-bottom:50px}\n", "", {"version":3,"sources":["/home/runner/work/greenline-web/greenline-web/web/js/components/wellness/pages/AdminWellnessDvmCommission.scss"],"names":[],"mappings":"AAAA,kCAAM,kBAAkB,CAAC","file":"AdminWellnessDvmCommission.scss","sourcesContent":[".root{margin-bottom:50px}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"root": "AdminWellnessDvmCommission__root"
};